import React, { HTMLAttributes, PropsWithChildren } from 'react'

import { Menu } from '@services/api/menus'

import { Layout } from '@components/layout'

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  menus?: {
    main?: Menu[]
    footer1?: Menu[]
    footer2?: Menu[]
  }
  keyword?: string
  head?: {
    title?: string
    metaTitle?: string
    metaDescription?: string
    canonicalUrl?: string
    coverImage?: string
    twitter?: string
  }
}

export const Skeleton = ({
  menus = {},
  keyword = 'home',
  children,
  ...rest
}: PropsWithChildren<SkeletonProps>) => {
  return (
    <Layout
      sponsorKeyword={keyword}
      mainMenus={menus.main}
      footerMenus1={menus.footer1}
      footerMenus2={menus.footer2}
      {...rest}
    >
      {children}
    </Layout>
  )
}
